import React from 'react'
import { FaWhatsapp } from 'react-icons/fa'
import { MdLiveTv } from 'react-icons/md'
import { Link } from 'react-router-dom'
const Navbar = () => {
    return (
        <nav className="bg-gray-800 p-2 h-16 md:h-20    border-b border-slate-700 top-0 fixed z-50 w-full ">
            <div className="mx-1  md:mx-3 flex  justify-between items-center">
                <div className="text-white text-xl font-bold">
                    <Link to="/" className="flex gap-2 items-center">
                        <img
                            src="/isologo.png"
                            className="object-contain w-[175px] md:w-[200px]  "
                            alt="NETMAX Logo"
                        />
                    </Link>
                </div>
                <div className="flex gap-4  items-center">
                    <Link
                        to="/play"

                        rel="noopener noreferrer"
                        className="text-gray-300 flex items-center  text-[25px] md:text-[26px] gap-2 hover:text-white "
                    >
                        <MdLiveTv className="inline-block " />
                    </Link>
                    <Link
                        to="https://wa.me/5493571458075"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-300 flex items-center  text-[25px] md:text-[26px] gap-2 hover:text-white "
                    >
                        <FaWhatsapp className="inline-block " />
                    </Link>

                </div>
            </div>
        </nav>
    )
}
export default Navbar